import { removeExchangeFromTicker } from "utils/display";


export default ({ ticker, placeholder, bold }) =>
(<div style={{ display: 'flex', alignItems: 'center', gap: "10px" }}>
  <img src={`${process.env.REACT_APP_CDN_URL}/stocks/${removeExchangeFromTicker(ticker)}.png`} width={40} />
  <span style={{ fontWeight: bold ? 'bold' : 'normal', fontSize: "15px" }}>{ticker}</span>
</div>)